exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exporter span[data-v-655cd142]{font-weight:600;font-size:18px;margin:0 15px}", ""]);

// exports
